import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/hooks/useFetch";
import { fmtDate } from "@/lib/format";
import CloseDayFlow from "@/components/common/CloseDayFlow";

export default function CloseDay() {
  const { salesman, bizDate } = useAuth();
  const { data: reopened } = useFetch("/closures", { status: "REOPENED", limit: 10 });
  const [date, setDate] = useState(bizDate);
  const others = (reopened?.items || []).filter((c) => c.date !== bizDate);
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold tracking-tight">Close Day</h1>
      {others.length > 0 && (
        <div className="rounded border border-orange-200 bg-orange-50 p-3 text-sm" data-testid="reopened-days-banner">
          <p className="font-semibold text-orange-800">Reopened by admin — correction needed:</p>
          <div className="mt-2 flex flex-wrap gap-2">
            {[{ date: bizDate, label: `Today (${fmtDate(bizDate)})` }, ...others.map((c) => ({ date: c.date, label: fmtDate(c.date) }))].map((x) => (
              <button key={x.date} onClick={() => setDate(x.date)} data-testid={`close-date-${x.date}`}
                className={`rounded px-3 py-1.5 text-xs font-semibold ${date === x.date ? "bg-slate-900 text-white" : "bg-white text-slate-700"}`}>{x.label}</button>
            ))}
          </div>
        </div>
      )}
      <CloseDayFlow key={date} sid={salesman.id} date={date} />
    </div>
  );
}
